import React from "react";
import { ChakraProvider, CSSReset } from "@chakra-ui/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProtectedRoute from "../components/utils/ProtectedRoute";
import Login from "../pages/Flujo Basico/Login";
import ForgetPassword from "../pages/Flujo Basico/ForgetPassword";
import Register from "../pages/Flujo Basico/Register";
import Parents from "../pages/Parents/ParentsArea";
import DashboardHome from "../pages/Parents/HomeDashboad";
import FAQ from "../pages/Parents/FAQ";
import Setting from "../pages/Parents/Settings";
import Blog from "../pages/Parents/Blog";
import BlogDetails from "../pages/Parents/BlogDetails";
import Reportes from "../pages/Parents/Reportes";
import DashboardPage from "../pages/Kids/Dashboard";
import Game from "../pages/Kids/Game";
import Pruebas from "../pages/Flujo Basico/Pruebas";
import LandingPage from "../pages/Landing/LandingPage";
import KidSelector from "../pages/Kids/KidSelector";
import PageLoader from "../components/UI/PageLoader";
import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { useSelector } from "react-redux";

import { library } from '@fortawesome/fontawesome-svg-core'

// import your icons
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

Chart.register(CategoryScale);
Chart.register(ChartDataLabels);

function App() {
  const isLoading = useSelector((state) => state.loading.isLoading);

  return (
    <ChakraProvider>
      <CSSReset />
      {isLoading && <PageLoader />}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/ForgetPassword" element={<ForgetPassword />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/Parents" element={<ProtectedRoute><Parents /></ProtectedRoute>} />
          <Route path="/Dashboard" element={<ProtectedRoute><DashboardHome /></ProtectedRoute>} />
          <Route path="/Faq" element={<ProtectedRoute><FAQ /></ProtectedRoute>} />
          <Route path="/Settings" element={<ProtectedRoute><Setting /></ProtectedRoute>} />
          <Route path="/Blog" element={<ProtectedRoute><Blog /></ProtectedRoute>} />
          <Route path="/Blog/:idBlog" element={<ProtectedRoute><BlogDetails /></ProtectedRoute>} />
          <Route path="/Reportes" element={<ProtectedRoute><Reportes /></ProtectedRoute>} />
          <Route path="/Home" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/Game" element={<ProtectedRoute><Game /></ProtectedRoute>} />
          <Route path="/Pruebas" element={<Pruebas />} />
          <Route path="/Kids" element={<ProtectedRoute><KidSelector /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
library.add(fab, fas, far)